import api from "api";
import { leifGptApiBase } from "api/constants";
import { handleFinishReason } from "./finishReasonHandler";
import { base64toFile } from "../rjsf/GeneratorPicker/imageUtils";
import { generatePromptInstructions } from "../rjsf/GeneratorPicker/promtInstructions";

type Props = {
  prompt: string;
  base64Image?: string;
  disableContext?: boolean;
};

export const generateImage = async ({ prompt, base64Image, disableContext }: Props): Promise<Blob | null> => {
  try {
    const text = generatePromptInstructions(!!base64Image, prompt, !!disableContext);
    const formData = new FormData();
    formData.append("q", JSON.stringify([text]));
    if (base64Image) {
      const file = base64toFile(base64Image);
      formData.append("files", file);
    }
    formData.append("aspect_ratio", "16:9");

    const response = await api.call("/leif-gpt/generate_images", {
      method: "POST",
      root: leifGptApiBase,
      data: formData,
    });
    const result = await response.json();

    const finishReason = result.finish_reason || null;
    handleFinishReason(finishReason);

    const firstImage = result.images?.[0];

    if (firstImage?.image_data) {
      const mimeType = firstImage.mime_type || "image/png";
      const blob = new Blob([Uint8Array.from(atob(firstImage.image_data), c => c.charCodeAt(0))], {
        type: mimeType,
      });
      return blob;
    }

    return null;
  } catch (err) {
    console.error("Error generating image:", err);
    throw err;
  }
};
